import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message} from 'semantic-ui-react';
import { Formik, Form, Field } from 'formik';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import RegisterOtpSchema from './validate';

class FormsRegisterOtp extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there is an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const {updateStepIndex, email, name, OTPtype} = this.props;
        return (
            <Formik
                initialValues={{
                    otp: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={RegisterOtpSchema}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);
                    console.log({
                        nric: this.props.identifier,
                        otp: values.otp
                    })
                    this.setState({error: false, errorMessage: null});
                    this.props.registerVerifyOTPEmail({
                        nric: this.props.identifier,
                        otp: values.otp
                    }, (result, error) => {
                        if (error) {
                            this.setState({error: true, errorMessage: error.errorMessage});
                            actions.setSubmitting(false);
                        }
                        if (result) {
                            updateStepIndex(5, {});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Segment>
                        <Form>
                            <Header as='h2'>
                                One-Time Password
                            </Header>
                            <Divider />
                            <Message warning>
                                <Message.Header>
                                    {`${name}, ${OTPtype && OTPtype === 'EMAIL' ? 'Check your Email!' : 'Check your Phone!'}`}
                                </Message.Header>
                                <p>
                                    {`An OTP verification has been sent to your registered ${OTPtype && OTPtype === 'EMAIL' ? 'email address.' : 'phone number.'}`}
                                </p>
                            </Message>
                            <Field name="otp" label="One Time Password" component={FormsInputsText} secondaryLabel={`Please input the one time password that you can find in your ${OTPtype && OTPtype === 'EMAIL' ? 'mailbox.' : 'phone inbox.'}`}/>
                            <p>
                                &nbsp;
                            </p>
                            <Button type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>Verify One Time Password</Button>
                            <p>
                                &nbsp;
                            </p>
                            {
                                this.renderFormSubmissionResult()
                            }
                        </Form>
                    </Segment>
                )}
            />
        );
    }
}

export default FormsRegisterOtp;